module.exports = __webpack_public_path__ + "Icon_Holiday.a1f3d0c11eb751479206.png";